import React, { useState, useEffect } from 'react';
import logo from '../images/gif-720.gif';
import logoFooter from '../images/logo-footer.png';

const Navbar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const closeMenu = () => {
    setIsMenuOpen(false);
  };

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
    closeMenu();
  };

  return (
    <nav className={`navbar ${isScrolled ? 'navbar-scrolled' : ''}`}>
      <div className="navbar-container">
        <div className="navbar-logo" onClick={() => scrollToSection('hero')}>
          <div className="logo-icon">
            <img src={isMenuOpen ? logoFooter : logo} alt="Be Safe Keep Safe Logo" className="logo-img" />
          </div>
        </div>

        <div className={`hamburger ${isMenuOpen ? 'active' : ''}`} onClick={toggleMenu}>
          <span className="hamburger-line"></span>
          <span className="hamburger-line"></span>
          <span className="hamburger-line"></span>
        </div>

        <ul className={`nav-menu ${isMenuOpen ? 'active' : ''}`}>
          <li className="nav-item">
            <a href="#hero" onClick={(e) => { e.preventDefault(); scrollToSection('hero'); }}>
              <span className="nav-number">01</span>
              <span className="nav-text">Home</span>
            </a>
          </li>
          <li className="nav-item">
            <a href="#services" onClick={(e) => { e.preventDefault(); scrollToSection('services'); }}>
              <span className="nav-number">02</span>
              <span className="nav-text">Services</span>
            </a>
          </li>
          <li className="nav-item">
            <a href="#about" onClick={(e) => { e.preventDefault(); scrollToSection('about'); }}>
              <span className="nav-number">03</span>
              <span className="nav-text">About Us</span>
            </a>
          </li>
          <li className="nav-item">
            <a href="#testimonials" onClick={(e) => { e.preventDefault(); scrollToSection('testimonials'); }}>
              <span className="nav-number">04</span>
              <span className="nav-text">Testimonials</span>
            </a>
          </li>
          <li className="nav-item">
            <a href="#faq" onClick={(e) => { e.preventDefault(); scrollToSection('faq'); }}>
              <span className="nav-number">05</span>
              <span className="nav-text">FAQ</span>
            </a>
          </li>
          <li className="nav-item">
            <a href="#contact" onClick={(e) => { e.preventDefault(); scrollToSection('contact'); }}>
              <span className="nav-number">06</span>
              <span className="nav-text">Contact Us</span>
            </a>
          </li>
          <div className="nav-footer">
            <p>Get in touch</p>
            <a href="mailto:info@besafekeepsafe.co.uk">info@besafekeepsafe.co.uk</a>
          </div>
        </ul>
      </div>
    </nav>
  );
};

export default Navbar;
